import type {
  ContentProgress,
  ContentProgressSection,
} from "../../@types/portalAluno";

const toPercentage = (completed: number, total: number) =>
  total > 0 ? (completed / total) * 100 : 0;

const isSectionCompleted = (
  section: ContentProgressSection,
  completedIds: ReadonlySet<string>
) =>
  section.items.length > 0 &&
  section.items.every((item) => completedIds.has(item.id));

export const getCompletedItemIds = (
  sections: ContentProgressSection[]
): Set<string> =>
  new Set(
    sections.flatMap((section) =>
      section.items.filter((item) => item.completed).map((item) => item.id)
    )
  );

export const calculateProgressPercentage = (
  progress: Pick<ContentProgress, "basis" | "sections">,
  completedIds: ReadonlySet<string>
) => {
  const basis = progress.basis ?? "contents";
  const evaluationItems =
    basis === "contents"
      ? []
      : progress.sections
          .filter((section) => section.kind === "evaluation")
          .flatMap((section) => section.items);
  const completedEvaluations = evaluationItems.filter((item) =>
    completedIds.has(item.id)
  ).length;

  if (basis === "coursesAndEvaluations") {
    const courses = progress.sections.filter(
      (section) => section.kind === "course"
    );
    const completedCourses = courses.filter((section) =>
      isSectionCompleted(section, completedIds)
    ).length;

    return toPercentage(
      completedCourses + completedEvaluations,
      courses.length + evaluationItems.length
    );
  }

  const contentItems = progress.sections
    .filter((section) => section.kind !== "evaluation")
    .flatMap((section) => section.items);
  const completedContents = contentItems.filter((item) =>
    completedIds.has(item.id)
  ).length;

  return toPercentage(
    completedContents + completedEvaluations,
    contentItems.length + evaluationItems.length
  );
};
